import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FacebookShareButton, TwitterShareButton, LineShareButton, } from 'react-share';
import { propFunc, propStr } from '../../../helpers/custom-prop-types';
import ClipIcon from '../../Icon/Svg/ClipIcon';
import FacebookIcon from '../../Icon/Svg/FacebookIcon';
import LineIcon from '../../Icon/Svg/LineIcon';
import TwitterIcon from '../../Icon/Svg/TwitterIcon';
import Tooltip from '../../Ui/Tooltip/Tooltip';
const ShareList = (props) => {
    const { onClickClip, shareUrl, suffix, title } = props;
    const mergedTitle = suffix === '' ? title : `${title} | ${suffix}`;
    return (_jsxs("ul", Object.assign({ className: 'share_list' }, { children: [_jsx("li", Object.assign({ className: 'share_list_col' }, { children: _jsx(TwitterShareButton, Object.assign({ title: mergedTitle, url: shareUrl }, { children: _jsx(TwitterIcon, {}) })) })), _jsx("li", Object.assign({ className: 'share_list_col' }, { children: _jsx(FacebookShareButton, Object.assign({ quote: mergedTitle, url: shareUrl }, { children: _jsx(FacebookIcon, {}) })) })), _jsx("li", Object.assign({ className: 'share_list_col line' }, { children: _jsx(LineShareButton, Object.assign({ title: mergedTitle, url: shareUrl }, { children: _jsx(LineIcon, {}) })) })), _jsx("li", Object.assign({ className: 'share_list_col copy' }, { children: _jsx("button", Object.assign({ className: 'share_clip_button', onClick: onClickClip, type: 'button', value: shareUrl }, { children: _jsx(Tooltip, Object.assign({ html: _jsx("div", { children: "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC" }) }, { children: _jsx(ClipIcon, {}) })) })) }))] })));
};
ShareList.propTypes = {
    onClickClip: propFunc().isRequired,
    shareUrl: propStr().isRequired,
    suffix: propStr(),
    title: propStr().isRequired,
};
ShareList.defaultProps = {
    suffix: '',
};
export default ShareList;
